import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Headphones, Video, MessageCircle, Sparkles, LayoutTemplate, Warehouse, BookOpen } from 'lucide-react';
const baseItems = [{
  icon: Zap,
  title: 'Inmersión Intensiva (7D)',
  description: 'Construcción y lanzamiento asistido de tu maquinaria digital desde cero.'
}, {
  icon: Headphones,
  title: 'Acompañamiento Estratégico (90D)',
  description: '3 meses de soporte para asegurar que llegues a tus objetivos de facturación.'
}, {
  icon: Video,
  title: 'Círculo de Operadores (Zoom)',
  description: '1 Llamada semanal para auditar tiendas, anuncios y estrategia en vivo.'
}, {
  icon: MessageCircle,
  title: 'Soporte de Élite 24/7',
  description: 'Grupo privado para resolución de dudas en tiempo real.'
}];
const bonuses = [{
  icon: Sparkles,
  title: 'Dominio de Anuncios con IA',
  image: 'https://cdn.magicpatterns.com/uploads/2LBmDgiPtgfKCp3ezLNkVf/Ads_Command_Core_202604041706.jpg',
  description: 'Crea creativos que cortan el scroll y venden en segundos usando herramientas de IA.'
}, {
  icon: LayoutTemplate,
  title: 'Constructor de Páginas con IA',
  image: 'https://cdn.magicpatterns.com/uploads/otYxrgLMwb1zbtMYchpU5Z/AI_Page_Builder_202604041708.jpg',
  description: "Monta tu 'Máquina de Ventas' en minutos y con diseño profesional sin tocar una sola línea de código."
}, {
  icon: Warehouse,
  title: "Bodegas 'Ghost' Latam",
  image: 'https://cdn.magicpatterns.com/uploads/eTra2Nit4GQCe7KqDhg7b9/Futuristic_warehouse_with_202604041712.jpg',
  description: 'Acceso directo a proveedores con stock real en el país donde decidas vender.'
}, {
  icon: BookOpen,
  title: 'El Código de Infoproductos',
  image: 'https://cdn.magicpatterns.com/uploads/68HWWDteBXFQYdUmqm4c8i/Futuristic_book_code_202604041713.jpg',
  description: 'Mi sistema para crear y rentabilizar tus propios productos digitales desde cero.'
}];
export function ImmersionSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-38">
      {/* Base */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="text-center mb-10" data-id="element-39">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-3" data-id="element-40">
          Tu Hoja de Ruta Operativa
        </h2>
        <p className="text-gray-400 font-medium text-lg" data-id="element-41">
          La base de tu máquina de facturación
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-16" data-id="element-42">
        {baseItems.map((item, index) => {
        const Icon = item.icon;
        return <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className={`bg-[#0A0A0A] border border-[#1F1F1F] rounded-2xl overflow-hidden group hover:border-primary/30 transition-colors ${item.image ? '' : 'p-7'}`} data-id="element-43">
              {item.image && <div className="relative h-44 overflow-hidden" data-id="element-44">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-45" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent" data-id="element-46" />
                </div>}
              <div className={item.image ? 'p-7 -mt-6 relative z-10' : ''} data-id="element-47">
                <div className="flex items-start gap-4" data-id="element-48">
                  <div className="w-11 h-11 rounded-lg bg-primary/15 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/25 transition-colors" data-id="element-49">
                    <Icon className="w-5 h-5 text-primary" data-id="element-50" />
                  </div>
                  <div data-id="element-51">
                    <h3 className="text-lg font-bold text-white mb-1" data-id="element-52">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 font-medium leading-relaxed text-sm" data-id="element-53">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>;
      })}
      </div>

      {/* Bonuses */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="text-center mb-10" data-id="element-54">
        <h3 className="text-2xl sm:text-3xl font-extrabold text-white mb-3" data-id="element-55">
          Aceleradores con Inteligencia Artificial
        </h3>
        <p className="text-gray-400 font-medium" data-id="element-56">
          Bonos exclusivos incluidos en tu acceso
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-57">
        {bonuses.map((item, index) => {
        const Icon = item.icon;
        return <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className={`bg-[#0A0A0A] border border-[#1F1F1F] rounded-2xl overflow-hidden group hover:border-accent/30 transition-colors ${item.image ? '' : 'p-7'}`} data-id="element-58">
              {item.image && <div className="relative h-44 overflow-hidden" data-id="element-59">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-60" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent" data-id="element-61" />
                </div>}
              <div className={item.image ? 'p-7 -mt-6 relative z-10' : ''} data-id="element-62">
                <div className="flex items-start gap-4" data-id="element-63">
                  <div className="w-11 h-11 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0 group-hover:bg-accent/20 transition-colors" data-id="element-64">
                    <Icon className="w-5 h-5 text-accent" data-id="element-65" />
                  </div>
                  <div data-id="element-66">
                    <span className="inline-block px-2 py-0.5 rounded bg-accent/10 text-accent text-xs font-bold uppercase tracking-wider mb-2" data-id="element-67">
                      Bono Incluido
                    </span>
                    <h3 className="text-lg font-bold text-white mb-1" data-id="element-68">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 font-medium leading-relaxed text-sm" data-id="element-69">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>;
      })}
      </div>
    </section>;
}